import { useEffect } from "react";
import HooverHeroSection from "./components/HeroSection";
import HooverStickyNav from "./components/StickyNav";
import HooverProcessingTimeSection from "./components/ProcessingTimeSection";
import HooverServicesSection from "./components/ServicesSection";
import HooverLocalAreaSection from "./components/LocalAreaSection";
import HooverTravelTimingSection from "./components/TravelTimingSection";
import HooverDestinationsSection from "./components/DestinationsSection";
import HooverTestimonialsSection from "./components/TestimonialsSection";
import HooverAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import HooverComparisonSection from "./components/ComparisonSection";
import HooverMistakesSection from "./components/MistakesSection";
import HooverHowItWorksSection from "./components/HowItWorksSection";
import HooverFAQSection, { faqs } from "./components/FAQSection";
import HooverHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import HooverFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function HooverPage() {
  useEffect(() => {
    document.title = "Emergency Passport Hoover AL — Expedited Same-Day Service | Fast Passport Center";
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };
    const pageUrl = "https://fastpassportcenter.com/hoover/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Hoover, AL — as fast as 24 hours. Serving Riverchase executives, Vestavia Hills professionals, and Greater Birmingham south suburbs. A+ BBB rated, registered State Dept. courier.");
    setMeta("geo.placename", "Hoover, Alabama");
    setMeta("geo.region", "US-AL");
    setMeta("geo.position", "33.4050;-86.8113");
    setMeta("ICBM", "33.4050, -86.8113");
    const graph = [
      { "@type": "BreadcrumbList", itemListElement: [{ "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" }, { "@type": "ListItem", position: 2, name: "Alabama", item: "https://fastpassportcenter.com/alabama/" }, { "@type": "ListItem", position: 3, name: "Hoover Passport Services", item: pageUrl }] },
      { "@type": "LocalBusiness", name: "Fast Passport Center", description: "Emergency and expedited passport services for Hoover, Vestavia Hills, Pelham, and Greater Birmingham south suburbs — as fast as 24 hours.", url: pageUrl, telephone: "+1-877-253-0084", areaServed: { "@type": "City", name: "Hoover", containedInPlace: { "@type": "State", name: "Alabama" } }, priceRange: "$$$", openingHours: ["Mo-Fr 09:00-18:00"], aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" } },
      { "@type": "FAQPage", mainEntity: faqs.map((faq) => ({ "@type": "Question", name: faq.q, acceptedAnswer: { "@type": "Answer", text: faq.a } })) },
    ];
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-hoover";
    document.getElementById("structured-data-hoover")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);
    return () => { document.getElementById("structured-data-hoover")?.remove(); const canonical = document.querySelector('link[rel="canonical"]'); if (canonical) canonical.remove(); };
  }, []);

  return (
    <div className="font-sans">
      <HooverHeroSection />
      <HooverStickyNav />
      <HooverProcessingTimeSection />
      <HooverServicesSection />
      <HooverLocalAreaSection />
      <HooverTravelTimingSection />
      <HooverDestinationsSection />
      <HooverTestimonialsSection />
      <HooverAcceptanceFacilitiesSection />
      <HooverComparisonSection />
      <HooverMistakesSection />
      <HooverHowItWorksSection />
      <HooverFAQSection />
      <HooverHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/hoover" state="AL" />
      <HooverFinalCTA />
    </div>
  );
}